import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  main_beneficial_owners_rate: {
    name: 'Beneficially owned percentage by top 5 beneficial owners',
    order: 118
  },
  professional_investor_concentration_rate: {
    name: 'Investor Concentration percentage by professional clients',
    order: 119
  },
  retail_investor_concentration_rate: {
    name: 'Investor Concentration percentage by retail investors',
    order: 120
  }
};

export function InvestorConcetration({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_CONCENTRATION,
    onChangeFund,
    schema: schema.INVESTOR_CONCENTRATION,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_CONCENTRATION?.field_names || [],
    columnLables,
    tableName: 'INVESTOR_CONCENTRATION',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="reporttables-investor-concentration-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
